import React, {FC, useState} from 'react'
import cn from "classnames";
import {DatePicker} from 'antd'
import dayjs from 'dayjs'

import {InputNew} from "@UI/InputNew";
import Button from "@UI/Button";

import s from './index.module.css'
import {useAddAlert} from "@/hooks/useAddAlert";
import {useInputNew} from "@UI/InputNew/useInputNew";
import {directionOrdersApi, usersAPI} from "@/api";

type Props = {
    setState: (data: any) => void,
    closeModal: () => void,
    data: any
}

export const ChangeBalance: FC<Props> = ({ data, setState, closeModal }) => {
    const resolveBalance = data.privateInfo ? (
        data.privateInfo.currency === 'rub' ? String(Math.round(Number(data.children.balance))) : (
            data.privateInfo.currency === 'euro' ? data.children.balance_euro : data.children.balance_dollar )
        ) : (
        data.tariff.currency === 'rub' ? String(Math.round(Number(data.children.balance))) : (
            data.tariff.currency === 'euro' ? data.tariff.balance_euro : data.children.balance_dollar
        )
    )

    const resolveCurrency = data.privateInfo
        ? (typeof data.privateInfo.currency === 'string' ? data.privateInfo.currency : (
            data.privateInfo.currency === data.children.balance ? 'rub' : (
                data.privateInfo.currency === data.children.balance_euro ? 'euro' : 'dollar'
            )
        ))
        : data.tariff.currency;

    function restrictFloatBalanceOnRuble()
    {
        if (resolveCurrency === 'rub') {
            document.querySelectorAll('input').forEach(item => {
                item.onkeyup = () => {
                    if (!item.value.match('/0-9/')) {
                        item.value = item.value.replace(/[^0-9]/g, '');
                    }
                }
            });
        }
    }
    const [isLoading, setIsLoading] = useState(false)
    const [balance, setBalance] = useState(resolveBalance);
    const [changeDate, setChangeDate] = useState(dayjs())
    const [errorsList, setErrorsList] = React.useState<{valid: boolean}>({valid: false})
    const [showErrors, setShowErrors] = React.useState(false)
    const addAlert = useAddAlert()

    // @ts-ignore
    const [bindLink] = useInputNew({
        name: 'balance',
        value: String(balance),
        onChange: e => setBalance(e),
        placeholder: '0',
        errorText: 'Поле не может быть пустым',
        onError: setErrorsList,
        validate: showErrors,
    })

    const save = async () => {
        const normalizedGroupBalance = String(balance).trim().replace(',', '.')
        const isGroupPerLesson = data?.tariff?.type === 'group_per_lesson'
        if (isGroupPerLesson && !/^\d+(?:\.\d{1,2})?$/.test(normalizedGroupBalance)) {
            addAlert({type: 'error', title: 'Введите корректное неотрицательное значение баланса'})
            return
        }

        var nextPaymentDate = null;
        if (data?.tariff?.type == 'month' && data?.next_payment_date !== null) {
            nextPaymentDate = data?.next_payment_date.toString();
        }
        const newData = {
            "order_id": data.id,
            "amount": isGroupPerLesson
                ? Number(normalizedGroupBalance)
                : Number(balance) - Number(resolveBalance),
            "currency": resolveCurrency,
            "manual_payment": 1,
            "next_payment_date": nextPaymentDate,
            "number_hours": 0,
            "created_at": changeDate.format('YYYY-MM-DD HH:mm:ss'),
        }

        setShowErrors(true)
        if (errorsList.valid) {
            setIsLoading(true)
            var user = data.children;
            if (resolveCurrency === 'rub') {
                user.balance = balance;
            } else if (resolveCurrency === 'euro') {
                user.balance_euro = balance;
            } else {
                user.balance_dollar = balance;
            }
            await usersAPI.updateBalance({id: user.id, data: user});
            directionOrdersApi.extendByManager({
                data: newData,
                params: {
                    type: data?.tariff?.type === 'hour' || data?.tariff?.type === 'minute' ? 'manager-hour' : 'manager-month',
                    expand: `orderPayments.order`
                }
            }).then(response => {
                setIsLoading(false)
                addAlert({title: 'Баланс изменен!'})
                closeModal()
                setTimeout(() => window.location.reload(), 500);
            })
        }
    }

    return (
        <div className={cn(s.wrapper, s.modalBalance)}>
            <h2 className="modal__title">Изменить баланс</h2>

            <div>
                <p className={s.descr}>Баланс ({resolveCurrency === 'rub'
                    ? "₽" : (resolveCurrency === 'dollar' ? "$" : '€')}):</p>

                {/*@ts-ignore*/}
                <InputNew onChange={restrictFloatBalanceOnRuble()} placeholder="1200" className={s.fullWidth} {...bindLink} />

            </div>

            <div>
                <p className={s.descr}>Дата и время изменения</p>
                <DatePicker
                    showTime={{format: 'HH:mm'}}
                    value={changeDate}
                    onChange={(date) => setChangeDate(date ?? dayjs())}
                    format="DD.MM.YYYY HH:mm"
                    className={s.dateField}
                />
            </div>

            <Button name='Сохранить' styles='accent' action={save} loading={isLoading} className={s.marginTop} />
        </div>
    )
}
